import { ApiError, ParamsNotFoundError } from '../../helpers/definedErrors';
import { api } from '../../config';

export const startRecording = async (params = null) => {
  if (!params) {
    params = JSON.parse(sessionStorage.getItem('spParams'));
    if (!params) {
      console.error('No params were found!');
      throw new ParamsNotFoundError();
    }
    try {
      const url = `/v1/installs/${params.installSid}/exams/${params.examSid}/sessions/${params.sessionSid}/recording`;
      const headers = {
        token: params.token,
      };
      const payload = {
        action: 'start',
      };
      const response = await api.put(url, headers, payload);
      return {
        success: true,
        data: response.data
      }
    } catch (error) {

      if(error?.response?.data && error?.response?.data?.code === '1571'){
        return {
          success: false,
          message: error?.response?.data?.message
        }
      }

      throw new ApiError();
    }
  }
};
